var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardWaveHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 19,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 2,
    height: 19,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.454 8.592a4.897 4.897 0 0 1 8.168.182l.144.243a2.986 2.986 0 0 0 4.898.482l.135-.173 1.385-1.913a1 1 0 0 1 1.687 1.067l-.067.107-1.385 1.912a4.986 4.986 0 0 1-8.404-.516 2.897 2.897 0 0 0-4.809-.399l-.11.147-1.274 1.839a1 1 0 0 1-1.709-1.032l.065-.108 1.276-1.838Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWaveHeight);
export default __webpack_public_path__ + "static/media/DashboardWaveHeight.23dcd67897ebd12cc3bf7fd5e29f5974.svg";
export { ForwardRef as ReactComponent };